export default {
  admin: 'ادمین',
  profile: 'پروفایل',
  logout: 'خروج',
  login: 'ورود',
  register: 'ثبت نام',
  forgotPassword: 'فراموشی رمز عبور',
  dontHaveAnAccount: 'حساب کاربری ندارید؟',
  JoinFreeToday: 'رایگان ثبت نام کن',
  haveAnAccount: 'حساب کاربری دارید؟',
  enterYourEmail: 'ایمیل خود را وارد کنید',
  enterYourFirstName: 'نام خود را وارد کنید',
  enterYourLastName: 'نام خانوادگی خود را وارد کنید',
  enterYourFullName: 'نام و نام خانوادگی خود را وارد کنید',
  enterYourMobile: 'شماره موبایل خود را وارد کنید',
  enterYourPassword: 'رمز عبور خود را وارد کنید',
  verifyMobileNumber: 'تایید شماره موبایل',
  resetPassword: 'بازیابی رمز عبور',
  enterTheCodeIsSentToYourMobileOrEmail: 'کد تایید به شماره موبایل یا ایمیل شما ارسال شد',
  enterYourPasswordAgain: 'رمز عبور خود را دوباره وارد کنید',
  loginViaOTP: 'ورود با کد امنیتی',
  loginViaPassword: 'ورود با رمز عبور',
  profileUpdated: 'پروفایل به روز شد',
  recoveryCodeSentToYourMobile: 'کد بازیابی به شماره موبایل شما ارسال شد',
  otpSentToYourMobile: 'کد امنیتی به شماره موبایل شما ارسال شد',
  changePassword: 'تغییر رمز عبور',
  resendCode: 'ارسال مجدد کد',
  loginByPassword: 'ورود با رمز عبور',
  sendOtp: 'ارسال کد امنیتی',
  passwordChanged: 'رمز عبور با موفقیت تغییر یافت',
  completeYourProfile: 'تکمیل پروفایل خود',
  createAccount: 'ثبت نام',
  loginNow: 'ورود',
  getStartWithApp: 'شروع کار با @:(branding.appTitle)',
  loginTOYourAccount: 'وارد حساب کاربری خود شوید',
  forgetPassword: 'فراموشی رمز عبور',
  emailOrUsername: 'ایمیل یا نام کاربری',
  welcomeBack: 'خوش آمدید',
  welcome: 'خوش آمدید'
}
